module.exports = __webpack_public_path__ + "static/media/Yrsa-Light.d9d7b6a9.ttf";